import { render, staticRenderFns } from "./TahsilatRaporDetay.vue?vue&type=template&id=71009515&"
import script from "./TahsilatRaporDetay.vue?vue&type=script&lang=js&"
export * from "./TahsilatRaporDetay.vue?vue&type=script&lang=js&"
import style0 from "./TahsilatRaporDetay.vue?vue&type=style&index=0&id=71009515&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports